import { useEffect } from 'react';
import styles from './SteamCardsPage.module.css';
import { Header } from '../../../components/Header/Header.jsx';
import { FooterBtn } from '../../../UI/FooterBtn/FooterBtn.jsx';
import { MinSliderCard } from '../../../components/Slider/minSliderCard/minSliderCard.jsx';
import { useLocation } from 'react-router-dom';

import { useAllItemsQuery } from '../../../store/api/item.api.js';

import catalogIcon from '../../../assets/catalog-icon.svg';
import supIcon from '../../../assets/support-icon.svg';

export const SteamCardsPage = () => {
	const location = useLocation();
	const schema = location.state?.schema || window.sessionStorage.getItem('schema');

	useEffect(() => {
		window.sessionStorage.setItem('schema', schema);
	}, [schema]);

	const { data: allItems = [], isLoading } = useAllItemsQuery({ schema });
	
	if (isLoading) return (<div>Loading...</div>);


	return (
		<div className='main'>
			<Header />
			<div className={'title_block'}>
				<img src={catalogIcon} alt="catalogIcon" />
				<h2>Ключи</h2>
			</div>
			<div className={styles.mainBlock}>
				{
					allItems?.map((item) => (
						<MinSliderCard
							from='steam'
							buyBtn={true}
							title={item.title}
							price={item.price}
							price_disc={item.price_disc}
							img={item.img}
							devices={item.regions}
							itemId={item.id}
						/>
					))
				}
			</div>
			<footer className={styles.footer}>
				<FooterBtn 
					img={supIcon}
					title={'Support'}
					description={'На всякий, если у вас будут вопросы'}
				/>
			</footer>
		</div>
	);
};
